import React from "react";

export function Pill({ children, tone = "neutral", className = "" }) {
  return <span className={`pill pill-${tone} ${className}`}>{children}</span>;
}

export function Modal({ open, onClose, title, children, footer, size = "md" }) {
  if (!open) return null;
  const maxW = size === "lg" ? "max-w-3xl" : size === "sm" ? "max-w-md" : "max-w-2xl";
  return (
    <div className="modal-bg" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} data-testid="modal-backdrop">
      <div className={`modal ${maxW} anim-in`} data-testid="modal">
        <div className="flex items-center justify-between p-5 border-b border-[var(--border)]">
          <div className="font-display text-lg font-bold tracking-tight text-zinc-900">{title}</div>
          <button className="btn btn-ghost btn-sm" onClick={onClose} data-testid="modal-close">✕</button>
        </div>
        <div className="p-5 space-y-4">{children}</div>
        {footer && <div className="px-5 py-4 border-t border-[var(--border)] flex justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}

export function Field({ label, children, span = 1 }) {
  return (
    <div className={span === 2 ? "col-span-2" : ""}>
      <label className="fld-lbl">{label}</label>
      {children}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="card flex flex-col items-center justify-center py-16 text-center px-6">
      {Icon && <Icon size={28} className="text-zinc-400 mb-3" strokeWidth={1.5} />}
      <div className="font-display text-base text-zinc-700 font-semibold">{title}</div>
      {hint && <div className="text-xs text-zinc-500 font-mono mt-2">{hint}</div>}
    </div>
  );
}
